export default __webpack_public_path__ + "static/media/iphone12.d37e64fa.png";